export var EButtonsOrientation = /* @__PURE__ */ ((EButtonsOrientation2) => {
  EButtonsOrientation2["STACK"] = "STACK";
  EButtonsOrientation2["INLINE"] = "INLINE";
  return EButtonsOrientation2;
})(EButtonsOrientation || {});
export var EImageOrVideoAlignment = /* @__PURE__ */ ((EImageOrVideoAlignment2) => {
  EImageOrVideoAlignment2["LEFT"] = "LEFT";
  EImageOrVideoAlignment2["RIGHT"] = "RIGHT";
  return EImageOrVideoAlignment2;
})(EImageOrVideoAlignment || {});
